"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = {
    id: "game-end",
    class: "game_end_cont"
};
const _hoisted_2 = { class: "game_end" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { class: "game_end_success" };
const _hoisted_6 = { class: "game_end_notice" };
const _hoisted_7 = { class: "game_end_list" };
const _hoisted_8 = { key: 1 };
const _hoisted_9 = { class: "game_end_fail" };
const _hoisted_10 = { class: "game_end_notice" };
const _hoisted_11 = { class: "game_end_list" };
const _hoisted_12 = { class: "game_end_navigation" };
const _hoisted_13 = { href: "new-game" };
const _hoisted_14 = { href: "." };
const _hoisted_15 = {
    key: 1,
    class: "game-end-winer-announcement"
};
const _hoisted_16 = { class: "game_end_victory_points" };
const _hoisted_17 = { class: "table game_end_table" };
const _hoisted_18 = ["data-tooltip"];
const _hoisted_19 = ["data-tooltip"];
const _hoisted_20 = { key: 0 };
const _hoisted_21 = { key: 1 };
const _hoisted_22 = { key: 2 };
const _hoisted_23 = { key: 3 };
const _hoisted_24 = ["data-tooltip"];
const _hoisted_25 = {
    key: 5,
    class: "clock-icon"
};
const _hoisted_26 = ["data-tooltip"];
const _hoisted_27 = ["href"];
const _hoisted_28 = { class: "column-corporation" };
const _hoisted_29 = { key: 0 };
const _hoisted_30 = { key: 1 };
const _hoisted_31 = { key: 2 };
const _hoisted_32 = { key: 3 };
const _hoisted_33 = { key: 4 };
const _hoisted_34 = { class: "game-end-total" };
const _hoisted_35 = { class: "game-end-mc" };
const _hoisted_36 = { key: 5 };
const _hoisted_37 = { class: "game-end-timer" };
const _hoisted_38 = { class: "game-end-timer" };
const _hoisted_39 = { class: "game-end-flexrow" };
const _hoisted_40 = { class: "game-end-winer-scorebreak-player-title" };
const _hoisted_41 = ["href"];
const _hoisted_42 = { class: "game-end-column-row" };
const _hoisted_43 = { class: "game-end-column-vp" };
const _hoisted_44 = { class: "game-end-column-text" };
const _hoisted_45 = { class: "game-end-column-row" };
const _hoisted_46 = { class: "game-end-column-vp" };
const _hoisted_47 = { class: "game-end-column-text" };
const _hoisted_48 = { class: "game-end-column-row" };
const _hoisted_49 = { class: "game-end-column-vp" };
const _hoisted_50 = { class: "game-end-column-text" };
const _hoisted_51 = { class: "game-end-column-row" };
const _hoisted_52 = { class: "game-end-column-vp" };
const _hoisted_53 = { class: "game-end-column-text" };
const _hoisted_54 = { class: "game_end_victory_points" };
const _hoisted_55 = { class: "table game_end_table" };
const _hoisted_56 = { key: 0 };
const _hoisted_57 = { key: 1 };
const _hoisted_58 = { key: 2 };
const _hoisted_59 = { key: 3 };
const _hoisted_60 = { key: 0 };
const _hoisted_61 = { key: 1 };
const _hoisted_62 = { key: 2 };
const _hoisted_63 = { key: 3 };
const _hoisted_64 = { class: "game-end-total" };
const _hoisted_65 = { class: "game-end-flexrow" };
const _hoisted_66 = { class: "game_end_block--board game-end-column" };
const _hoisted_67 = { key: 1 };
const _hoisted_68 = { class: "game_end_block--log game-end-column" };
const _hoisted_69 = ["href"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_AppButton = (0, vue_1.resolveComponent)("AppButton");
    const _component_victory_point_chart = (0, vue_1.resolveComponent)("victory-point-chart");
    const _component_board = (0, vue_1.resolveComponent)("board");
    const _component_MoonBoard = (0, vue_1.resolveComponent)("MoonBoard");
    const _component_PlanetaryTracks = (0, vue_1.resolveComponent)("PlanetaryTracks");
    const _component_log_panel = (0, vue_1.resolveComponent)("log-panel");
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("h1", null, [
            (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.constants.APP_NAME) + " - Game finished!", 1)
        ])), [
            [_directive_i18n]
        ]),
        (0, vue_1.createElementVNode)("div", _hoisted_2, [
            (_ctx.isSoloGame)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_3, [
                    (_ctx.game.isSoloModeWin)
                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_4, [
                            (0, vue_1.createElementVNode)("div", _hoisted_5, [
                                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("h2", null, [...(_cache[0] || (_cache[0] = [
                                        (0, vue_1.createTextVNode)("You win!", -1)
                                    ]))])), [
                                    [_directive_i18n]
                                ]),
                                _cache[6] || (_cache[6] = (0, vue_1.createElementVNode)("div", { class: "game_end_solo_img" }, [
                                    (0, vue_1.createElementVNode)("img", { src: "assets/solo_win.png" })
                                ], -1)),
                                (0, vue_1.createElementVNode)("div", _hoisted_6, [
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[1] || (_cache[1] = [
                                            (0, vue_1.createTextVNode)("But it isn't the reason to stop making Mars better.", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ])
                                ]),
                                (0, vue_1.createElementVNode)("ul", _hoisted_7, [
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[2] || (_cache[2] = [
                                            (0, vue_1.createTextVNode)("Try to win with expansions enabled", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ]),
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[3] || (_cache[3] = [
                                            (0, vue_1.createTextVNode)("Try to win before the last generation", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ]),
                                    (0, vue_1.createElementVNode)("li", null, [
                                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[4] || (_cache[4] = [
                                                (0, vue_1.createTextVNode)("Can you get", -1)
                                            ]))])), [
                                            [_directive_i18n]
                                        ]),
                                        (0, vue_1.createTextVNode)(" " + (0, vue_1.toDisplayString)(_ctx.players[0].victoryPointsBreakdown.total + 10), 1),
                                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[5] || (_cache[5] = [
                                                (0, vue_1.createTextVNode)("+ Victory Points?", -1)
                                            ]))])), [
                                            [_directive_i18n]
                                        ])
                                    ])
                                ])
                            ])
                        ]))
                        : ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_8, [
                            (0, vue_1.createElementVNode)("div", _hoisted_9, [
                                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("h2", null, [...(_cache[7] || (_cache[7] = [
                                        (0, vue_1.createTextVNode)("Sorry, you lose.", -1)
                                    ]))])), [
                                    [_directive_i18n]
                                ]),
                                (0, vue_1.createElementVNode)("div", _hoisted_10, [
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[8] || (_cache[8] = [
                                            (0, vue_1.createTextVNode)("Next time you will get more luck!", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ]),
                                    _cache[10] || (_cache[10] = (0, vue_1.createElementVNode)("br", null, null, -1)),
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[9] || (_cache[9] = [
                                            (0, vue_1.createTextVNode)("Also, take into account these small hints to win:", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ])
                                ]),
                                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("ul", _hoisted_11, [...(_cache[11] || (_cache[11] = [
                                        (0, vue_1.createElementVNode)("li", null, "Concentrate more on Global parameters, not on Victory Points", -1),
                                        (0, vue_1.createElementVNode)("li", null, "Don't be greedy with card selection", -1),
                                        (0, vue_1.createElementVNode)("li", null, "Try to increase heat production, not Megacredits", -1),
                                        (0, vue_1.createElementVNode)("li", null, "Try starting with the Beginner corporation", -1)
                                    ]))])), [
                                    [_directive_i18n]
                                ])
                            ])
                        ]))
                ]))
                : (0, vue_1.createCommentVNode)("", true),
            (0, vue_1.createElementVNode)("div", _hoisted_12, [
                (0, vue_1.createElementVNode)("div", null, [
                    (0, vue_1.createElementVNode)("a", _hoisted_13, [
                        (0, vue_1.createVNode)(_component_AppButton, {
                            size: "big",
                            type: "back"
                        }),
                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[12] || (_cache[12] = [
                                (0, vue_1.createTextVNode)("Create New Game", -1)
                            ]))])), [
                            [_directive_i18n]
                        ])
                    ]),
                    (0, vue_1.createElementVNode)("a", _hoisted_14, [
                        (0, vue_1.createVNode)(_component_AppButton, {
                            size: "big",
                            type: "back"
                        }),
                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[13] || (_cache[13] = [
                                (0, vue_1.createTextVNode)("Go to main page", -1)
                            ]))])), [
                            [_directive_i18n]
                        ])
                    ])
                ])
            ]),
            (!_ctx.isSoloGame || _ctx.game.isSoloModeWin)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_15, [
                    ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.winners, (p) => {
                        return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", {
                            key: p.color
                        }, [
                            (0, vue_1.createElementVNode)("span", {
                                class: (0, vue_1.normalizeClass)('log-player ' + _ctx.getEndGamePlayerRowColorClass(p.color))
                            }, (0, vue_1.toDisplayString)(p.name), 3)
                        ]));
                    }), 128)),
                    _cache[15] || (_cache[15] = (0, vue_1.createTextVNode)()),
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[14] || (_cache[14] = [
                            (0, vue_1.createTextVNode)("won!", -1)
                        ]))])), [
                        [_directive_i18n]
                    ])
                ]))
                : (0, vue_1.createCommentVNode)("", true),
            (0, vue_1.createElementVNode)("div", _hoisted_16, [
                (0, vue_1.createElementVNode)("h2", null, [
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[16] || (_cache[16] = [
                            (0, vue_1.createTextVNode)("Victory point breakdown after", -1)
                        ]))])), [
                        [_directive_i18n]
                    ]),
                    (0, vue_1.createTextVNode)(" " + (0, vue_1.toDisplayString)(_ctx.game.generation) + " ", 1),
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[17] || (_cache[17] = [
                            (0, vue_1.createTextVNode)("generations", -1)
                        ]))])), [
                        [_directive_i18n]
                    ])
                ]),
                (0, vue_1.createElementVNode)("table", _hoisted_17, [
                    (0, vue_1.createElementVNode)("thead", null, [
                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("tr", null, [
                            _cache[22] || (_cache[22] = (0, vue_1.createElementVNode)("th", null, [
                                (0, vue_1.createElementVNode)("div", { class: "card-delegate" })
                            ], -1)),
                            _cache[23] || (_cache[23] = (0, vue_1.createElementVNode)("th", null, [
                                (0, vue_1.createElementVNode)("div", { class: "tr" })
                            ], -1)),
                            (0, vue_1.createElementVNode)("th", null, [
                                (0, vue_1.createElementVNode)("div", {
                                    class: "m-and-a tooltip tooltip-top",
                                    "data-tooltip": _ctx.$t('Milestones points')
                                }, "M", 8, _hoisted_18)
                            ]),
                            (0, vue_1.createElementVNode)("th", null, [
                                (0, vue_1.createElementVNode)("div", {
                                    class: "m-and-a tooltip tooltip-top",
                                    "data-tooltip": _ctx.$t('Awards points')
                                }, "A", 8, _hoisted_19)
                            ]),
                            _cache[24] || (_cache[24] = (0, vue_1.createElementVNode)("th", null, [
                                (0, vue_1.createElementVNode)("div", { class: "table-forest-tile" })
                            ], -1)),
                            _cache[25] || (_cache[25] = (0, vue_1.createElementVNode)("th", null, [
                                (0, vue_1.createElementVNode)("div", { class: "table-city-tile" })
                            ], -1)),
                            (_ctx.game.moon !== undefined)
                                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("th", _hoisted_20, [...(_cache[18] || (_cache[18] = [
                                        (0, vue_1.createElementVNode)("div", { class: "table-moon-road-tile" }, null, -1)
                                    ]))]))
                                : (0, vue_1.createCommentVNode)("", true),
                            (_ctx.game.moon !== undefined)
                                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("th", _hoisted_21, [...(_cache[19] || (_cache[19] = [
                                        (0, vue_1.createElementVNode)("div", { class: "table-moon-colony-tile" }, null, -1)
                                    ]))]))
                                : (0, vue_1.createCommentVNode)("", true),
                            (_ctx.game.moon !== undefined)
                                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("th", _hoisted_22, [...(_cache[20] || (_cache[20] = [
                                        (0, vue_1.createElementVNode)("div", { class: "table-moon-mine-tile" }, null, -1)
                                    ]))]))
                                : (0, vue_1.createCommentVNode)("", true),
                            (_ctx.game.pathfinders !== undefined)
                                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("th", _hoisted_23, [...(_cache[21] || (_cache[21] = [
                                        (0, vue_1.createElementVNode)("div", { class: "table-planetary-track" }, null, -1)
                                    ]))]))
                                : (0, vue_1.createCommentVNode)("", true),
                            _cache[26] || (_cache[26] = (0, vue_1.createElementVNode)("th", null, [
                                (0, vue_1.createElementVNode)("div", { class: "vp" }, "VP")
                            ], -1)),
                            (_ctx.game.gameOptions.escapeVelocity)
                                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("th", {
                                    key: 4,
                                    class: "clock-icon tooltip tooltip-top",
                                    "data-tooltip": _ctx.$t('Escape Velocity penalty')
                                }, "⏳", 8, _hoisted_24))
                                : (0, vue_1.createCommentVNode)("", true),
                            _cache[27] || (_cache[27] = (0, vue_1.createElementVNode)("th", { class: "game-end-total" }, [
                                (0, vue_1.createElementVNode)("div", { class: "game-end-total-column" }, "Total")
                            ], -1)),
                            _cache[28] || (_cache[28] = (0, vue_1.createElementVNode)("th", null, [
                                (0, vue_1.createElementVNode)("div", { class: "mc-icon" })
                            ], -1)),
                            (_ctx.game.gameOptions.showTimers)
                                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("th", _hoisted_25, "🕑"))
                                : (0, vue_1.createCommentVNode)("", true),
                            (0, vue_1.createElementVNode)("th", null, [
                                (0, vue_1.createElementVNode)("div", {
                                    class: "table-red-arrow tooltip tooltip-top",
                                    "data-tooltip": _ctx.$t('Actions taken this game')
                                }, null, 8, _hoisted_26)
                            ])
                        ])), [
                            [_directive_i18n]
                        ])
                    ]),
                    (0, vue_1.createElementVNode)("tbody", null, [
                        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.playersInPlace, (p) => {
                            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("tr", {
                                key: p.color,
                                class: (0, vue_1.normalizeClass)(_ctx.getEndGamePlayerRowColorClass(p.color))
                            }, [
                                (0, vue_1.createElementVNode)("td", null, [
                                    (0, vue_1.createElementVNode)("a", {
                                        href: 'player?id=' + p.id + '&noredirect'
                                    }, (0, vue_1.toDisplayString)(p.name), 9, _hoisted_27),
                                    (0, vue_1.createElementVNode)("div", _hoisted_28, [
                                        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.getCorporationName(p), (corporationName, index) => {
                                            return (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", { key: index }, [
                                                (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(corporationName), 1)
                                            ])), [
                                                [_directive_i18n]
                                            ]);
                                        }), 128))
                                    ])
                                ]),
                                (0, vue_1.createElementVNode)("td", null, (0, vue_1.toDisplayString)(p.victoryPointsBreakdown.terraformRating), 1),
                                (0, vue_1.createElementVNode)("td", null, (0, vue_1.toDisplayString)(p.victoryPointsBreakdown.milestones), 1),
                                (0, vue_1.createElementVNode)("td", null, (0, vue_1.toDisplayString)(p.victoryPointsBreakdown.awards), 1),
                                (0, vue_1.createElementVNode)("td", null, (0, vue_1.toDisplayString)(p.victoryPointsBreakdown.greenery), 1),
                                (0, vue_1.createElementVNode)("td", null, (0, vue_1.toDisplayString)(p.victoryPointsBreakdown.city), 1),
                                (_ctx.game.moon !== undefined)
                                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("td", _hoisted_29, (0, vue_1.toDisplayString)(p.victoryPointsBreakdown.moonRoads), 1))
                                    : (0, vue_1.createCommentVNode)("", true),
                                (_ctx.game.moon !== undefined)
                                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("td", _hoisted_30, (0, vue_1.toDisplayString)(p.victoryPointsBreakdown.moonHabitats), 1))
                                    : (0, vue_1.createCommentVNode)("", true),
                                (_ctx.game.moon !== undefined)
                                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("td", _hoisted_31, (0, vue_1.toDisplayString)(p.victoryPointsBreakdown.moonMines), 1))
                                    : (0, vue_1.createCommentVNode)("", true),
                                (_ctx.game.pathfinders !== undefined)
                                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("td", _hoisted_32, (0, vue_1.toDisplayString)(p.victoryPointsBreakdown.planetaryTracks), 1))
                                    : (0, vue_1.createCommentVNode)("", true),
                                (0, vue_1.createElementVNode)("td", null, (0, vue_1.toDisplayString)(p.victoryPointsBreakdown.victoryPoints), 1),
                                (_ctx.game.gameOptions.escapeVelocity)
                                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("td", _hoisted_33, (0, vue_1.toDisplayString)(p.victoryPointsBreakdown.escapeVelocity), 1))
                                    : (0, vue_1.createCommentVNode)("", true),
                                (0, vue_1.createElementVNode)("td", _hoisted_34, (0, vue_1.toDisplayString)(p.victoryPointsBreakdown.total), 1),
                                (0, vue_1.createElementVNode)("td", _hoisted_35, [
                                    (0, vue_1.createElementVNode)("div", null, (0, vue_1.toDisplayString)(p.megaCredits), 1)
                                ]),
                                (_ctx.game.gameOptions.showTimers)
                                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("td", _hoisted_36, [
                                        (0, vue_1.createElementVNode)("div", _hoisted_37, (0, vue_1.toDisplayString)(_ctx.getTimer(p)), 1)
                                    ]))
                                    : (0, vue_1.createCommentVNode)("", true),
                                (0, vue_1.createElementVNode)("td", null, [
                                    (0, vue_1.createElementVNode)("div", _hoisted_38, (0, vue_1.toDisplayString)(p.actionsTakenThisGame), 1)
                                ])
                            ], 2));
                        }), 128))
                    ])
                ]),
                _cache[31] || (_cache[31] = (0, vue_1.createElementVNode)("br", null, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("h2", null, [...(_cache[29] || (_cache[29] = [
                        (0, vue_1.createTextVNode)("Victory points details", -1)
                    ]))])), [
                    [_directive_i18n]
                ]),
                (0, vue_1.createVNode)(_component_victory_point_chart, {
                    datasets: _ctx.vpDataset,
                    generation: _ctx.game.generation,
                    animation: true,
                    id: 'victory-point-chart'
                }, null, 8, ["datasets", "generation"]),
                (0, vue_1.createElementVNode)("div", _hoisted_39, [
                    ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.playersInPlace, (p) => {
                        return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                            key: p.color,
                            class: "game-end-column"
                        }, [
                            (0, vue_1.createElementVNode)("div", _hoisted_40, [
                                (0, vue_1.createElementVNode)("div", {
                                    class: (0, vue_1.normalizeClass)('game-end-player ' + _ctx.getEndGamePlayerRowColorClass(p.color))
                                }, [
                                    (0, vue_1.createElementVNode)("a", {
                                        href: 'player?id=' + p.id + '&noredirect'
                                    }, (0, vue_1.toDisplayString)(p.name), 9, _hoisted_41)
                                ], 2)
                            ]),
                            ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(p.victoryPointsBreakdown.detailsCards, (v) => {
                                return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                    key: v.cardName
                                }, [
                                    (0, vue_1.createElementVNode)("div", _hoisted_42, [
                                        (0, vue_1.createElementVNode)("div", _hoisted_43, (0, vue_1.toDisplayString)(v.victoryPoint), 1),
                                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_44, [
                                            (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(v.cardName), 1)
                                        ])), [
                                            [_directive_i18n]
                                        ])
                                    ])
                                ]));
                            }), 128)),
                            _cache[30] || (_cache[30] = (0, vue_1.createElementVNode)("div", { class: "game-end-column-row" }, [
                                (0, vue_1.createElementVNode)("div", { class: "game-end-column-vp" }, " "),
                                (0, vue_1.createElementVNode)("div", { class: "game-end-column-text" }, " ")
                            ], -1)),
                            ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(p.victoryPointsBreakdown.detailsMilestones, (v) => {
                                return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                    key: v.message
                                }, [
                                    (0, vue_1.createElementVNode)("div", _hoisted_45, [
                                        (0, vue_1.createElementVNode)("div", _hoisted_46, (0, vue_1.toDisplayString)(v.victoryPoint), 1),
                                        (0, vue_1.createElementVNode)("div", _hoisted_47, (0, vue_1.toDisplayString)(_ctx.translateMilestoneDetails(v)), 1)
                                    ])
                                ]));
                            }), 128)),
                            ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(p.victoryPointsBreakdown.detailsAwards, (v) => {
                                return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                    key: v.message
                                }, [
                                    (0, vue_1.createElementVNode)("div", _hoisted_48, [
                                        (0, vue_1.createElementVNode)("div", _hoisted_49, (0, vue_1.toDisplayString)(v.victoryPoint), 1),
                                        (0, vue_1.createElementVNode)("div", _hoisted_50, (0, vue_1.toDisplayString)(_ctx.translateAwardDetails(v)), 1)
                                    ])
                                ]));
                            }), 128)),
                            ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(p.victoryPointsBreakdown.detailsPlanetaryTracks, (v) => {
                                return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                    key: v.tag
                                }, [
                                    (0, vue_1.createElementVNode)("div", _hoisted_51, [
                                        (0, vue_1.createElementVNode)("div", _hoisted_52, (0, vue_1.toDisplayString)(v.points), 1),
                                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_53, [
                                            (0, vue_1.createTextVNode)("Most tags on the " + (0, vue_1.toDisplayString)(v.tag) + " track", 1)
                                        ])), [
                                            [_directive_i18n]
                                        ])
                                    ])
                                ]));
                            }), 128))
                        ]));
                    }), 128))
                ])
            ]),
            (0, vue_1.createElementVNode)("div", _hoisted_54, [
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("h2", null, [...(_cache[32] || (_cache[32] = [
                        (0, vue_1.createTextVNode)("Global Parameter Contributions", -1)
                    ]))])), [
                    [_directive_i18n]
                ]),
                (0, vue_1.createElementVNode)("table", _hoisted_55, [
                    (0, vue_1.createElementVNode)("thead", null, [
                        (0, vue_1.createElementVNode)("tr", null, [
                            _cache[37] || (_cache[37] = (0, vue_1.createElementVNode)("th", null, [
                                (0, vue_1.createElementVNode)("div", { class: "card-delegate" })
                            ], -1)),
                            _cache[38] || (_cache[38] = (0, vue_1.createElementVNode)("th", null, [
                                (0, vue_1.createElementVNode)("div", { class: "tile temperature-tile" })
                            ], -1)),
                            _cache[39] || (_cache[39] = (0, vue_1.createElementVNode)("th", null, [
                                (0, vue_1.createElementVNode)("div", { class: "tile oxygen-tile" })
                            ], -1)),
                            _cache[40] || (_cache[40] = (0, vue_1.createElementVNode)("th", null, [
                                (0, vue_1.createElementVNode)("div", { class: "tile ocean-tile" })
                            ], -1)),
                            (_ctx.game.gameOptions.expansions.venus)
                                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("th", _hoisted_56, [...(_cache[33] || (_cache[33] = [
                                        (0, vue_1.createElementVNode)("div", { class: "tile venus-tile" }, null, -1)
                                    ]))]))
                                : (0, vue_1.createCommentVNode)("", true),
                            (_ctx.game.gameOptions.expansions.moon)
                                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("th", _hoisted_57, [...(_cache[34] || (_cache[34] = [
                                        (0, vue_1.createElementVNode)("div", { class: "table-moon-colony-tile" }, null, -1)
                                    ]))]))
                                : (0, vue_1.createCommentVNode)("", true),
                            (_ctx.game.gameOptions.expansions.moon)
                                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("th", _hoisted_58, [...(_cache[35] || (_cache[35] = [
                                        (0, vue_1.createElementVNode)("div", { class: "table-moon-mine-tile" }, null, -1)
                                    ]))]))
                                : (0, vue_1.createCommentVNode)("", true),
                            (_ctx.game.gameOptions.expansions.moon)
                                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("th", _hoisted_59, [...(_cache[36] || (_cache[36] = [
                                        (0, vue_1.createElementVNode)("div", { class: "table-moon-road-tile" }, null, -1)
                                    ]))]))
                                : (0, vue_1.createCommentVNode)("", true),
                            _cache[41] || (_cache[41] = (0, vue_1.createElementVNode)("th", null, [
                                (0, vue_1.createElementVNode)("div", { class: "game-end-total-column" }, "Total")
                            ], -1))
                        ])
                    ]),
                    (0, vue_1.createElementVNode)("tbody", null, [
                        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.playerContributionsData, (data) => {
                            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("tr", {
                                key: data.color,
                                class: (0, vue_1.normalizeClass)(_ctx.getEndGamePlayerRowColorClass(data.color))
                            }, [
                                (0, vue_1.createElementVNode)("td", null, (0, vue_1.toDisplayString)(data.player), 1),
                                (0, vue_1.createElementVNode)("td", null, (0, vue_1.toDisplayString)(data.temp), 1),
                                (0, vue_1.createElementVNode)("td", null, (0, vue_1.toDisplayString)(data.oxygen), 1),
                                (0, vue_1.createElementVNode)("td", null, (0, vue_1.toDisplayString)(data.oceans), 1),
                                (_ctx.game.gameOptions.expansions.venus)
                                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("td", _hoisted_60, (0, vue_1.toDisplayString)(data.venus), 1))
                                    : (0, vue_1.createCommentVNode)("", true),
                                (_ctx.game.gameOptions.expansions.moon)
                                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("td", _hoisted_61, (0, vue_1.toDisplayString)(data.moonHabitat), 1))
                                    : (0, vue_1.createCommentVNode)("", true),
                                (_ctx.game.gameOptions.expansions.moon)
                                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("td", _hoisted_62, (0, vue_1.toDisplayString)(data.moonMining), 1))
                                    : (0, vue_1.createCommentVNode)("", true),
                                (_ctx.game.gameOptions.expansions.moon)
                                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("td", _hoisted_63, (0, vue_1.toDisplayString)(data.moonLogistics), 1))
                                    : (0, vue_1.createCommentVNode)("", true),
                                (0, vue_1.createElementVNode)("td", _hoisted_64, (0, vue_1.toDisplayString)(data.total), 1)
                            ], 2));
                        }), 128))
                    ])
                ])
            ]),
            (0, vue_1.createElementVNode)("div", _hoisted_65, [
                (0, vue_1.createElementVNode)("div", _hoisted_66, [
                    (0, vue_1.createVNode)(_component_victory_point_chart, {
                        datasets: _ctx.globalsDataset,
                        generation: _ctx.game.generation,
                        animation: true,
                        id: 'global-parameter-chart',
                        yAxisLabel: '% completed'
                    }, null, 8, ["datasets", "generation"]),
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("h2", null, [...(_cache[42] || (_cache[42] = [
                            (0, vue_1.createTextVNode)("Final situation on the board", -1)
                        ]))])), [
                        [_directive_i18n]
                    ]),
                    (0, vue_1.createVNode)(_component_board, {
                        spaces: _ctx.game.spaces,
                        expansions: _ctx.game.gameOptions.expansions,
                        venusScaleLevel: _ctx.game.venusScaleLevel,
                        altVenusBoard: _ctx.game.gameOptions.altVenusBoard,
                        boardName: _ctx.game.gameOptions.boardName,
                        oceans_count: _ctx.game.oceans,
                        oxygen_level: _ctx.game.oxygenLevel,
                        temperature: _ctx.game.temperature
                    }, null, 8, ["spaces", "expansions", "venusScaleLevel", "altVenusBoard", "boardName", "oceans_count", "oxygen_level", "temperature"]),
                    (_ctx.game.moon !== undefined)
                        ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_MoonBoard, {
                            key: 0,
                            model: _ctx.game.moon
                        }, null, 8, ["model"]))
                        : (0, vue_1.createCommentVNode)("", true),
                    (_ctx.game.gameOptions.expansions.pathfinders)
                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_67, [
                            (0, vue_1.createVNode)(_component_PlanetaryTracks, {
                                tracks: _ctx.game.pathfinders,
                                gameOptions: _ctx.game.gameOptions
                            }, null, 8, ["tracks", "gameOptions"])
                        ]))
                        : (0, vue_1.createCommentVNode)("", true)
                ]),
                (0, vue_1.createElementVNode)("div", _hoisted_68, [
                    (0, vue_1.createVNode)(_component_log_panel, {
                        color: _ctx.color,
                        viewModel: _ctx.viewModel
                    }, null, 8, ["color", "viewModel"]),
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                        href: _ctx.downloadLogUrl,
                        target: "_blank"
                    }, [...(_cache[43] || (_cache[43] = [
                            (0, vue_1.createTextVNode)("Download game log", -1)
                        ]))], 8, _hoisted_69)), [
                        [_directive_i18n]
                    ])
                ])
            ])
        ])
    ]));
}
